import { useEffect, useState } from 'react';
import {
  ficouNoAntigo,
  lembrarQueFicouNoAntigo,
  perguntarLadoDoWelcome,
  urlDeEntradaNoWelcome,
} from '../services/welcomeAbService';

/**
 * Pergunta o sorteio do A/B quando a conta nova iria abrir o assistente.
 *
 * @param {boolean} abriria só true quando o assistente ABRIRIA — assim ele não chega a montar
 *   antes da resposta (montado, já grava sessão e rastreia passo).
 * @returns {'antigo' | null} null = esperando a resposta, ou já saindo para o Welcome novo.
 */
export function useLadoDoWelcome(abriria) {
  const [resposta, setResposta] = useState(null);
  const perguntar = abriria && !ficouNoAntigo();

  useEffect(() => {
    if (!perguntar) return undefined;
    let ativo = true;
    perguntarLadoDoWelcome().then((lado) => {
      if (!ativo) return;
      if (lado === 'novo') {
        window.location.replace(urlDeEntradaNoWelcome());
        return;
      }
      lembrarQueFicouNoAntigo();
      setResposta('antigo');
    });
    return () => {
      ativo = false;
    };
  }, [perguntar]);

  return perguntar ? resposta : 'antigo';
}
